import { ENVIRONMENT } from 'constants/environment';

const prodEnvs = ['biz-tecma-prod'];
const isProd = () => {
  return prodEnvs.includes(ENVIRONMENT.REACT_APP_NAMESPACE);
};

export default isProd;
